import React from 'react'
import Param from '../store/param';

import FormSetup from './formSetup';

const FormAfo = () => {
  const activeStep = Param.Get('activeStep');

  switch (activeStep) {
    case 0:
      return <FormSetup/>;
    default:
      return 'Unknown step';
  }
}

export default FormAfo